// extracted by mini-css-extract-plugin
export default {"root":"Sidebar_root__NCkuU","show":"Sidebar_show__HlW8X","offerBox":"Sidebar_offerBox__Af6Vw","selected":"Sidebar_selected__UrtW9","movein":"Sidebar_movein__sbTyH"};